
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "ISSVD_classification",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ISSVD_classification.vue